import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import CategoriesList from '../../components/CategoriesList/CategoriesList';
import classes from './Home.css';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import * as categoriesActions from '../../actions/CategoriesActions';
import * as menuActions from '../../actions/MenuActions';
import { Helmet } from 'react-helmet';
import { Carousel } from 'react-responsive-carousel';
import CategoryItemMobile from '../../components/CategoryItem/CategoryItemMobile';
// import BSMexicoLogo from '../../assets/logos/benito-santos-mexico.svg';
// import BSNoviasLogo from '../../assets/logos/benito-santos-novias.svg';
// import BSReadyToWearLogo from '../../assets/logos/benito-santos-ready-to-wear.svg';
// import TailorMadeImage from '../../assets/images/cat-tailor-made.png';
// import BridesImage from '../../assets/images/cat-brides.png';
// import ReadyToWearImage from '../../assets/images/cat-ready-to-wear.png';
import ArrowLeftIcon from '../../assets/icons/arrow-left.svg';
import ArrowRightIcon from '../../assets/icons/arrow-right.svg';

class Home extends Component {
    state = {
        logoClasses: [classes.LogoContainer],
        imageIndex: 0
    };

    componentDidMount() {
        this.props.hideAllMenus().then(() => {
            this.props.showLeftMenu();
        });

        this.props.getCategories();
    }

    hideLogoHandler = () => {
        // console.log('Hide Logo');
        this.setState({
            logoClasses: [classes.LogoContainer, classes.Hidden]
        });
    };

    unhideLogoHandler = () => {
        // console.log('Unhide Logo');
        this.setState({
            logoClasses: [classes.LogoContainer]
        });
    };

    handleArrowClick(event, direction) {
        switch (direction) {
            case 'prev':
                this.setState(prevState => {
                    return {
                        imageIndex:
                            prevState.imageIndex > 0
                                ? prevState.imageIndex - 1
                                : 0
                    };
                });
                break;
            case 'next':
                this.setState(prevState => {
                    return {
                        imageIndex:
                            prevState.imageIndex < 2
                                ? prevState.imageIndex + 1
                                : 2
                    };
                });
                break;
            default:
        }
    }

    handleCarouselChange = index => {
        this.setState({ imageIndex: index });
    };

    render() {
        const { imageIndex } = this.state;
        const { categories } = this.props;

        const imageOrigin = `${
            process.env.REACT_APP_API_URL
        }/api/containers/files/download/`;

        return (
            <Layout {...this.props.location}>
                <Helmet>
                    <title>Benito Santos - México</title>
                </Helmet>
                <section className={classes.Categories}>
                    <div className={this.state.logoClasses.join(' ')}>
                        <img src={BSMLogo} alt="Benito Santos - México" />
                    </div>
                    <CategoriesList
                        mouseEnter={this.hideLogoHandler}
                        mouseLeave={this.unhideLogoHandler}
                        items={categories.items}
                    />
                </section>
                <div className={'container ' + classes.CategoriesMobile}>
                    <Carousel
                        showThumbs={false}
                        showArrows={false}
                        showStatus={false}
                        showIndicators={false}
                        infiniteLoop={false}
                        emulateTouch={false}
                        selectedItem={imageIndex}
                        className={classes.Carousel}
                        onChange={this.handleCarouselChange}
                    >
                        {categories.items.length > 0 ? (
                            categories.items.map((category, index) => {
                                const imageURL =
                                    category.image.length > 0
                                        ? imageOrigin + category.image[0].name
                                        : '';

                                const logoURL =
                                    category.logo.length > 0
                                        ? imageOrigin + category.logo[0].name
                                        : '';

                                return (
                                    <CategoryItemMobile
                                        key={index}
                                        logo={logoURL}
                                        name={category.name}
                                        image={imageURL}
                                        link={`/colecciones/${category.slug}`}
                                        gold={category.slug === 'novias'}
                                    />
                                );
                            })
                        ) : (
                            <div style={{ marginTop: 40 }}>Cargando...</div>
                        )}
                    </Carousel>
                    {imageIndex > 0 ? (
                        <div
                            onClick={e => this.handleArrowClick(e, 'prev')}
                            className={
                                classes.ArrowButton +
                                ' ' +
                                classes.LeftArrowButton
                            }
                        >
                            <img src={ArrowLeftIcon} alt="" />
                        </div>
                    ) : null}
                    {imageIndex < 2 ? (
                        <div
                            onClick={e => this.handleArrowClick(e, 'next')}
                            className={
                                classes.ArrowButton +
                                ' ' +
                                classes.RightArrowButton
                            }
                        >
                            <img src={ArrowRightIcon} alt="" />
                        </div>
                    ) : null}
                </div>
                <div className={classes.StoreButtonContainer}>
                    <a
                        className={classes.StoreButton}
                        href="https://bit.ly/3PGnSqs"
                        target="_blank"
                    >
                        Tienda en Línea
                    </a>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        categories: state.categories
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...categoriesActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js